exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal {\n    overflow-y: auto;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /builds/johannes-jonsson/consmin-app/~/css-loader?{"sourceMap":false,"importLoaders":1}!/builds/johannes-jonsson/consmin-app/~/postcss-loader?{"ident":"postcss"}!/builds/johannes-jonsson/consmin-app/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = 2